'use client'

import { useCallback } from 'react'
import { useQuery } from '@tanstack/react-query'
import { X } from 'lucide-react'

import { Button } from '@ui/web/components'

import { useSharedTRPC } from '../../../../context'

interface DownloadInvoiceButtonProps {
  invoiceId: string
}

export function DownloadInvoiceButton({ invoiceId }: DownloadInvoiceButtonProps) {
  const trpc = useSharedTRPC()

  const {
    data: getPdfData,
    isPending: isPendingGetPdfData,
    isError: isErrorGetPdfData,
    refetch: refetchGetPdfData,
  } = useQuery({ ...trpc.invoice.getPdf.queryOptions({ invoiceId }), staleTime: 1000 * 60 * 60 })

  const handleDownload = useCallback(() => {
    if (!getPdfData) return

    // Convert base64 to blob and download
    const byteCharacters = atob(getPdfData.pdf)
    const byteArray = new Uint8Array(byteCharacters.length)
    for (let i = 0; i < byteCharacters.length; i++) {
      byteArray[i] = byteCharacters.charCodeAt(i)
    }
    const blob = new Blob([byteArray], { type: 'application/pdf' })

    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = `PiBo_${getPdfData.invoiceNumber}.pdf`
    a.click()
    URL.revokeObjectURL(url)
  }, [getPdfData])

  if (isErrorGetPdfData) {
    return (
      <Button
        variant='link'
        className='srd:text-main-blue-100 srd:text-nowrap srd:p-0 srd:w-fit srd:flex srd:items-center srd:justify-center srd:h-fit'
        onClick={() => refetchGetPdfData()}
      >
        <X className='srd:size-4 srd:mr-2 srd:text-main-blue-100' />
        Error. Coba lagi
      </Button>
    )
  }

  if (isPendingGetPdfData) {
    return (
      <Button
        variant='link'
        className='srd:text-main-blue-100 srd:text-nowrap srd:p-0 srd:w-fit srd:flex srd:items-center srd:justify-center srd:h-fit'
        disabled
        loading
      >
        Tunggu sebentar...
      </Button>
    )
  }

  return (
    <Button
      variant='link'
      className='srd:text-main-blue-100 srd:text-nowrap srd:p-0 srd:w-fit srd:flex srd:items-center srd:justify-center srd:h-fit'
      onClick={handleDownload}
    >
      {getPdfData.invoiceNumber}
    </Button>
  )
}
